<template>
  <section style="background: #fff" id="showcases" class="showcases section-bg">
    <img src="../../assets/images/topline.png" class="topline" />
    <img src="../../assets/images/Gallery.png" class="imgtitle" />
    <el-row :gutter="6" style="z-index: 1">
      <el-col :sm="24" :md="4" :lg="4" :xl="4">
        <viewer>
          <img
            :src="require('../../assets/images/gallery1.png')"
            :data-original="require('../../assets/images/gq1.jpg')"
            class="img1"
          />
        </viewer>
      </el-col>
      <el-col :sm="24" :md="5" :lg="5" :xl="5">
        <viewer>
          <img
            :src="require('../../assets/images/gallery2.png')"
            :data-original="require('../../assets/images/gq2.jpg')"
            class="img2_1"
          />
        </viewer>
        <viewer>
          <img
            :src="require('../../assets/images/gallery3.png')"
            :data-original="require('../../assets/images/gq4.jpg')"
            class="img2_2"
          />
        </viewer>
      </el-col>
      <el-col :sm="24" :md="6" :lg="6" :xl="6">
        <viewer>
          <img
            :src="require('../../assets/images/gallery4.png')"
            :data-original="require('../../assets/images/gq7.jpg')"
            class="img3"
          />
        </viewer>
      </el-col>
      <el-col :sm="24" :md="4" :lg="4" :xl="4">
        <viewer>
          <img
            :src="require('../../assets/images/gallery5.png')"
            :data-original="require('../../assets/images/gq6.jpg')"
            class="img3"
          />
        </viewer>
      </el-col>
      <el-col :sm="24" :md="5" :lg="5" :xl="5">
        <viewer>
          <img
            :src="require('../../assets/images/gallery6.png')"
            :data-original="require('../../assets/images/gq3.jpg')"
            class="img2_1"
          />
        </viewer>
        <viewer>
          <img
            :src="require('../../assets/images/gallery7.png')"
            :data-original="require('../../assets/images/gq5.jpg')"
            class="img2_2"
          />
        </viewer>
      </el-col>
    </el-row>
  </section>
</template>

<script>
export default {
  name: 'AboutUs',
  data () {
    return {
      ylArr4: require('../../assets/images/gq7.jpg'),
      ylArr5: require('../../assets/images/gq6.jpg'),
      ylArr6: require('../../assets/images/gq3.jpg'),
      ylArr7: require('../../assets/images/gq5.jpg'),
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.imgtitle {
  width: 400px;
  height: 80px;
  margin-bottom: 50px;
}
.img1 {
  /* width: 289px; */
  width: 100%;
  height: 396px;
  /deep/.el-image-viewer__wrapper
    .el-image-viewer__canvas
    .el-image-viewer__img {
    max-width: 80% !important;
    max-height: 80% !important;
  }
}
.img2_1 {
  /* max-width: 100%; */
  /* width: 363px; */
  width: 100%;
  height: 196px;
  margin-bottom: 4px;
  display: block;
  /deep/.el-image-viewer__wrapper
    .el-image-viewer__canvas
    .el-image-viewer__img {
    max-width: 80% !important;
    max-height: 80% !important;
  }
}
.img2_2 {
  /* max-width: 100%; */
  /* width: 363px; */
  width: 100%;
  height: 196px;
  display: block;
  /deep/.el-image-viewer__wrapper
    .el-image-viewer__canvas
    .el-image-viewer__img {
    max-width: 80% !important;
    max-height: 80% !important;
  }
}
.img3 {
  /* width: 435px; */
  width: 100%;
  height: 398px;
  /deep/.el-image-viewer__wrapper
    .el-image-viewer__canvas
    .el-image-viewer__img {
    max-width: 80% !important;
    max-height: 80% !important;
  }
}
.topline {
  width: 1px;
  height: 50px;
  margin: 0 auto;
  position: absolute;
  top: 146px;
}
</style>
